import { create } from 'zustand';
import { PointStore } from '../types/map';

export const usePointStore = create<PointStore>()((set) => ({
  fwePoints: [],
  setFWEPoints: (data) => set({ fwePoints: data }),

  inSituPoints: [],
  setInSituPoints: (data) => set({ inSituPoints: data }),

  selectedFwePoint: null,
  setSelectedFwePoint: (point) => set({ selectedFwePoint: point }),

  selectedInsituPoint: null,
  setSelectedInsituPoint: (point) => set({ selectedInsituPoint: point }),

  activePopupPoint: '',
  setActivePopupPoint: (point) => set({ activePopupPoint: point }),

  addPointName: '',
  setAddPointName: (point) => set({ addPointName: point }),
}));
